import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "@/store";
import type { Breadcrumb } from "@/types/view";

type SliceState = {
  currentRoute: string;
  breadCrumbs: Breadcrumb[];
};

const initialState: SliceState = {
  currentRoute: "",
  breadCrumbs: [],
};

export const externalEventSyncSlice = createSlice({
  name: "externalEventSync",
  initialState,
  reducers: {
    setCurrentRoute: (state, action: PayloadAction<string>) => {
      state.currentRoute = action.payload;
    },
    addBreadCrumbs: (state, action: PayloadAction<Breadcrumb[]>) => {
      state.breadCrumbs = action.payload;
    },
    removeBreadCrumbs: (state) => {
      state.breadCrumbs = [];
    },
  },
});

export const { setCurrentRoute, addBreadCrumbs, removeBreadCrumbs } =
  externalEventSyncSlice.actions;

export const currentRouteSelector = (state: RootState) =>
  state.externalEventSync.currentRoute;

export const breadCrumbSelector = (state: RootState) =>
  state.externalEventSync.breadCrumbs;

export default externalEventSyncSlice.reducer;
